export interface KioskLocationMeta {
  id: string;
  name: string;
  building: string;
  floor: string;
  coords: { lat: number; lng: number };
  mapPosition: { x: number; y: number };
}

export const kioskLocations: KioskLocationMeta[] = [
  {
    id: "fc6e5e98-cbd3-42c2-8639-e75c7d5e97ee",
    name: "Main Lobby",
    building: "Main Building",
    floor: "1",
    coords: { lat: 33.7925, lng: -84.322 },
    mapPosition: { x: 50, y: 65 }
  },
  {
    id: "0c4b6300-e865-46bb-beed-71ca0267ed1a",
    name: "Emergency Entrance",
    building: "Emergency",
    floor: "Ground",
    coords: { lat: 33.79211, lng: -84.32164 },
    mapPosition: { x: 78, y: 52 }
  },
  {
    id: "f1bad73e-0db0-4f0b-9827-35f52865a789",
    name: "ER Triage Pods",
    building: "Emergency",
    floor: "Ground",
    coords: { lat: 33.79254, lng: -84.3221 },
    mapPosition: { x: 68, y: 48 }
  },
  {
    id: "0817524c-8fa5-42b7-ae85-aa3d08e62938",
    name: "ICU West Wing",
    building: "Critical Care",
    floor: "2",
    coords: { lat: 33.79301, lng: -84.32242 },
    mapPosition: { x: 55, y: 34 }
  },
  {
    id: "a2d85c7a-d23b-45d8-860d-a5b8d15d3f9a",
    name: "ICU East Wing",
    building: "Critical Care",
    floor: "2",
    coords: { lat: 33.79337, lng: -84.32195 },
    mapPosition: { x: 60, y: 28 }
  },
  {
    id: "df7ee99e-1dae-4b2d-b910-1433d0ba181f",
    name: "Surgical Lobby",
    building: "Surgical Pavilion",
    floor: "1",
    coords: { lat: 33.79266, lng: -84.3211 },
    mapPosition: { x: 45, y: 57 }
  },
  {
    id: "07fa2e11-d5c5-40f3-8165-7aecd0c8d034",
    name: "North Tower Lobby",
    building: "North Tower",
    floor: "Ground",
    coords: { lat: 33.79354, lng: -84.3214 },
    mapPosition: { x: 32, y: 42 }
  },
  {
    id: "c6d5d9f8-0520-43d6-ac1b-50015baa97a3",
    name: "Parking Deck Elevators",
    building: "Parking",
    floor: "2",
    coords: { lat: 33.79186, lng: -84.32195 },
    mapPosition: { x: 20, y: 68 }
  },
  // Legacy IDs for backward compatibility
  {
    id: "ER-ENTRANCE-01",
    name: "Emergency Entrance",
    building: "Emergency",
    floor: "Ground",
    coords: { lat: 33.79211, lng: -84.32164 },
    mapPosition: { x: 78, y: 52 }
  },
  {
    id: "ER-TRIAGE-02",
    name: "ER Triage Pods",
    building: "Emergency",
    floor: "Ground",
    coords: { lat: 33.79254, lng: -84.3221 },
    mapPosition: { x: 68, y: 48 }
  },
  {
    id: "ICU-WEST-01",
    name: "ICU West Wing",
    building: "Critical Care",
    floor: "2",
    coords: { lat: 33.79301, lng: -84.32242 },
    mapPosition: { x: 55, y: 34 }
  },
  {
    id: "ICU-EAST-01",
    name: "ICU East Wing",
    building: "Critical Care",
    floor: "2",
    coords: { lat: 33.79337, lng: -84.32195 },
    mapPosition: { x: 60, y: 28 }
  },
  {
    id: "SURGERY-LOBBY-01",
    name: "Surgical Lobby",
    building: "Surgical Pavilion",
    floor: "1",
    coords: { lat: 33.79266, lng: -84.3211 },
    mapPosition: { x: 45, y: 57 }
  },
  {
    id: "NORTH-TOWER-LOBBY",
    name: "North Tower Lobby",
    building: "North Tower",
    floor: "Ground",
    coords: { lat: 33.79354, lng: -84.3214 },
    mapPosition: { x: 32, y: 42 }
  },
  {
    id: "PARKING-DECK-02",
    name: "Parking Deck Elevators",
    building: "Parking",
    floor: "2",
    coords: { lat: 33.79186, lng: -84.32195 },
    mapPosition: { x: 20, y: 68 }
  },
  {
    id: "TEST-FLOOR-3",
    name: "Floor 3 Nursing Station",
    building: "Main Building",
    floor: "3",
    coords: { lat: 33.7925, lng: -84.322 },
    mapPosition: { x: 45, y: 45 }
  },
  {
    id: "TEST-FLOOR-4",
    name: "Floor 4 Patient Lounge",
    building: "Main Building",
    floor: "4",
    coords: { lat: 33.7925, lng: -84.322 },
    mapPosition: { x: 55, y: 55 }
  },
  {
    id: "TEST-FLOOR-5",
    name: "Floor 5 Specialty Clinic",
    building: "Main Building",
    floor: "5",
    coords: { lat: 33.7925, lng: -84.322 },
    mapPosition: { x: 35, y: 35 }
  }
];

const locationIndex = new Map(kioskLocations.map((loc) => [loc.id, loc]));

export function getLocationMeta(id: string): KioskLocationMeta {
  return (
    locationIndex.get(id) ?? {
      id,
      name: id || "Unmapped location",
      building: "Unknown",
      floor: "—",
      coords: { lat: 33.7925, lng: -84.322 },
      mapPosition: { x: 50, y: 50 }
    }
  );
}

export function formatLocationLabel(id: string) {
  const meta = getLocationMeta(id);
  return `${meta.name} (${meta.floor === "—" ? "n/a" : `Floor ${meta.floor}`})`;
}
